module.exports = __webpack_public_path__ + "img/box_pro_four_3.57952a81.jpg";